import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "outletName", "contactsContainer", "contactsLoading", "contactsEmpty", "hunterBtn"]
  static values = { resultId: Number, domain: String, suggestedName: String }

  open() {
    this.outletNameTarget.value = this.suggestedNameValue
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    // Don't auto-fetch Hunter.IO — user clicks the button manually
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) this.close()
  }

  async fetchContacts() {
    if (this.hasHunterBtnTarget) this.hunterBtnTarget.classList.add("hidden")
    this.contactsLoadingTarget.classList.remove("hidden")
    this.contactsContainerTarget.innerHTML = ""
    this.contactsEmptyTarget.classList.add("hidden")

    try {
      const response = await fetch(
        `/pr/discovery_results/${this.resultIdValue}/hunter_contacts?domain=${encodeURIComponent(this.domainValue)}`,
        { headers: { "Accept": "application/json" } }
      )
      const data = await response.json()
      this.contactsLoadingTarget.classList.add("hidden")

      if (data.contacts && data.contacts.length > 0) {
        this.renderContacts(data.contacts)
        // Use organization name from Hunter.io if available
        if (data.organization && data.organization.trim() !== "") {
          this.outletNameTarget.value = data.organization
        }
      } else {
        this.contactsEmptyTarget.classList.remove("hidden")
      }
    } catch (e) {
      this.contactsLoadingTarget.classList.add("hidden")
      this.contactsEmptyTarget.classList.remove("hidden")
    }
  }

  renderContacts(contacts) {
    contacts.forEach((contact, index) => {
      const row = document.createElement("div")
      row.className = "flex items-start gap-3 p-3 rounded-lg border border-[#E8E4DF] hover:bg-[#F5F3F0] transition-colors"
      row.innerHTML = `
        <label class="flex items-center pt-1.5 cursor-pointer">
          <input type="checkbox" name="contacts[${index}][selected]" value="1"
                 class="rounded border-[#E8E4DF] text-[#C4A484] focus:ring-[#C4A484]">
        </label>
        <div class="flex-1 min-w-0 space-y-1.5">
          <div class="flex gap-2">
            <input type="text" name="contacts[${index}][first_name]" value="${this.escapeHtml(contact.first_name || '')}"
                   placeholder="First name" class="flex-1 px-2 py-1 text-sm rounded border border-[#E8E4DF] focus:ring-1 focus:ring-[#C4A484] focus:border-[#C4A484]">
            <input type="text" name="contacts[${index}][last_name]" value="${this.escapeHtml(contact.last_name || '')}"
                   placeholder="Last name" class="flex-1 px-2 py-1 text-sm rounded border border-[#E8E4DF] focus:ring-1 focus:ring-[#C4A484] focus:border-[#C4A484]">
          </div>
          <p class="text-xs text-[#8C8C8C]">${this.escapeHtml(contact.email)}</p>
          <input type="text" name="contacts[${index}][position]" value="${this.escapeHtml(contact.position || '')}"
                 placeholder="Role / position" class="w-full px-2 py-1 text-xs rounded border border-[#E8E4DF] focus:ring-1 focus:ring-[#C4A484] focus:border-[#C4A484] text-[#8C8C8C]">
          <input type="hidden" name="contacts[${index}][email]" value="${this.escapeHtml(contact.email)}">
        </div>
        <span class="text-xs text-[#8C8C8C] shrink-0 pt-1.5">${contact.confidence}%</span>
      `
      this.contactsContainerTarget.appendChild(row)
    })
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
